import React from 'react';
import './map-elements.less';

import MapContainer from './map';
import MapPlaceHolder from './mapPlaceholder';
import ErrorBoundary from '../../js/ErrorBoundary';

function MapHolder({ shouldGoogleMapsLoad, language }) {
  return (
    <div className="map-holder">
      <ErrorBoundary location="Google Maps" errorComponent={null}>
        {shouldGoogleMapsLoad ? (
          <MapContainer language={language} />
        ) : (
          <MapPlaceHolder language={language} />
        )}
      </ErrorBoundary>
    </div>
  );
}

export default MapHolder;
